import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-logged-out-layout',
  templateUrl: './logged-out-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoggedOutLayoutComponent {}
